<template>
  <div class="app-container">
    <el-card class="mb5">
      <el-form size="small" label-position="top">
        <div class="searchContainer">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item>
                <template slot="label">
                  <el-select
                    v-model="queryForm.params.timeField"
                    :placeholder="$t('operationCenter.PleaseSelect')"
                    style="width: 100%; height:  28px;"
                  >
                    <el-option
                      v-for="item in dateTime"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </template>
                <el-date-picker
                  v-model="data"
                  type="daterange"
                  :start-placeholder="$t('operationCenter.startDate')"
                  :end-placeholder="$t('operationCenter.endDate')"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 100%;"
                  clearable
                  :picker-options="pickerOptions"
                  :default-time="['00:00:00', '23:59:59']"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 状态 -->
              <el-form-item :label="$t('basicData.status')">
                <el-select
                  v-model="queryForm.params.status"
                  :placeholder="$t('operationCenter.PleaseSelect')"
                  clearable
                  style="width: 100%;"
                >
                  <el-option
                    v-for="item in STATUS"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 费用类型 -->
              <el-form-item :label="$t('basicData.ExpenseType')">
                <el-input
                  v-model="queryForm.params.expenseType"
                  :placeholder="$t('receivablePayable.InputFuzzyMatching')"
                  clearable
                  style="width: 100%;"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 成本中心 -->
              <el-form-item :label="$t('receivablePayable.CostCenter')">
                <el-input
                  v-model="queryForm.params.costCenter"
                  :placeholder="$t('receivablePayable.InputFuzzyMatching')"
                  clearable
                  style="width: 100%;"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 大区 -->
              <el-form-item :label="$t('receivablePayable.Region')">
                <el-input
                  v-model="queryForm.params.area"
                  :placeholder="$t('receivablePayable.InputFuzzyMatching')"
                  clearable
                  style="width: 100%;"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 州 -->
              <el-form-item :label="$t('GlobalSetObj.Estado')">
                <el-input
                  v-model="queryForm.params.state"
                  :placeholder="$t('receivablePayable.InputFuzzyMatching')"
                  clearable
                  style="width: 100%;"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 网点 -->
              <el-form-item :label="$t('basicData.Outlets')">
                <el-input
                  v-model="queryForm.params.station"
                  :placeholder="$t('receivablePayable.InputFuzzyMatching')"
                  clearable
                  style="width: 100%;"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 审批单编号 -->
              <el-form-item :label="$t('receivablePayable.ApprovalFormNumber')">
                <el-input
                  v-model="queryForm.params.serialNumber"
                  :placeholder="$t('receivablePayable.InputFuzzyMatching')"
                  clearable
                  style="width: 100%;"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <el-button
        type="primary" size="small" icon="el-icon-search"
        @click="handleQuery"
      >{{ $t('newOrder.search') }}</el-button>

      <el-button size="small" icon="el-icon-refresh-left" @click="onReset">
        {{ $t('operationCenter.reset') }}
      </el-button>
    </el-card>

    <el-card>
      <div class="table-but">
        <!-- 汇率维护 -->
        <el-button
          v-permit:remove="'btn:finance:reportDashboard:feishu:paymentDetails:exchangeRate'"
          size="small"
          type="primary"
          @click="asyncExchangeRate"
        >{{ $t('receivablePayable.ExchangeRateMaintenance') }}</el-button>

        <!-- 导出 -->
        <el-popover
          placement="bottom-start"
          trigger="hover"
        >
          <div class="feet">
            <el-button
              v-permit:remove="'btn:finance:reportDashboard:feishu:paymentDetails:export'"
              size="small"
              type="primary"
              @click="asyncApiStatisticsExport(1)"
            >{{ $t('basicData.ExportOnlyListData') }}</el-button>

            <el-button
              v-permit:remove="'btn:finance:reportDashboard:feishu:paymentDetails:exportAll'"
              class="feet-btn"
              size="small"
              type="primary"
              @click="asyncApiStatisticsExport(2)"
            >{{ $t('basicData.FullExportWithAttachments') }}</el-button>
          </div>
          <el-button
            slot="reference"
            size="small"
            type="info"
            icon="el-icon-download"
          >{{ $t('receivablePayable.Export') }}</el-button>
        </el-popover>
      </div>

      <el-table
        :data="tableData"
        border
        class="table-height"
        :height="tableHeightRow.height"
      >
        <el-table-column :label="$t('operationCenter.ind')" width="80px" align="center">
          <template slot-scope="scope">
            <span>{{ (queryForm.pageNumber - 1) * queryForm.pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <template v-for="item of Table_Column">
          <el-table-column
            :key="item.code"
            :label="item.label"
            :min-width="item.width"
            :prop="item.prop"
            :class-name="item.className"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="item.prop === 'status'">
                <el-tag :type="STATUS[scope.row.status] ? STATUS[scope.row.status].type : 'info'">
                  {{ STATUS[scope.row.status].label || '-' }}
                </el-tag>
              </span>
              <span v-else-if="item.prop === 'attachmentList'">
                <div class="flex fileView">
                  <template v-if="scope.row.attachmentList && scope.row.attachmentList.length > 0">
                    <!-- 显示前3个文件（按上传时间倒序） -->
                    <el-link
                      v-for="(key, index) in getDisplayFiles(scope.row.attachmentList)"
                      :key="key.id"
                      type="success"
                      @click="previewFile(scope.row, getOriginalIndex(scope.row.attachmentList, key))"
                    >{{ key.fileName }}</el-link>

                    <!-- 超过3个文件显示更多按钮 -->
                    <el-popover
                      v-if="scope.row.attachmentList.length > 3"
                      placement="bottom-start"
                      trigger="hover"
                      popper-class="file-list-popover"
                    >
                      <div class="file-list-container">
                        <div
                          v-for="(file, idx) in scope.row.attachmentList"
                          :key="file.id"
                          class="file-item"
                          @click="handleFileClick(scope.row, idx)"
                        >
                          <el-link type="success">{{ file.fileName }}</el-link>
                        </div>
                      </div>
                      <el-link slot="reference" type="primary">...({{ scope.row.attachmentList.length - 3 }})</el-link>
                    </el-popover>
                  </template>
                </div>
              </span>
              <span v-else>{{ scope.row[item.prop] }}</span>
            </template>
          </el-table-column>
        </template>
        <!--操作-->
        <el-table-column
          :label="$t('basicData.operate')"
          align="center"
          width="140"
          fixed="right"
        >
          <template #default="scope">
            <el-button
              v-permit:remove="'btn:finance:reportDashboard:feishu:paymentDetails:exportAttachment'"
              plain
              size="mini"
              @click="exportFile(scope.row)"
            >{{ $t('basicData.ExportAttachments') }}</el-button> <!--导出附件-->
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页工具 -->
      <div class="pagination">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="queryForm.pageNumber"
          :page-sizes="[10, 20, 50, 100]"
          :page-size.sync="queryForm.pageSize"
          :total="total"
          background
          style="margin: 10px 0"
          @current-change="getPageNumber"
          @size-change="getPageSize"
        />
      </div>
    </el-card>

    <el-drawer
      :visible.sync="exchangeRateDialogVisible"
      direction="ltr"
      size="60%"
    >
      <div slot="title" class="drawer_title">
        <h4 style="margin: 0;">{{ $t('receivablePayable.ExchangeRateMaintenance') }}</h4>

        <div class="tips">
          <i class="el-icon-warning-outline" />
          {{ $t('receivablePayable.BaseCurrencyIsBrl') }}</div>
      </div>

      <ExchangeRateForm ref="exchangeRateFormRef" @close="close" />
    </el-drawer>
  </div>
</template>

<script>
import estimateTableHeight from '@/views/finance/mixins/estimateTableHeight.js';
import { dateTime, STATUS, Table_Column } from './enums';
import {
  apiFeishuExpensePage,
  apiFeishuExpenseExport,
  apiFeishuExpenseExportAll,
  apiLarkExpenseExportAttachment
} from '@/api/finance/dataDheet';
import { goFinanceExportPage } from '@/utils/goExportList';
import ExchangeRateForm from './exchangeRateForm.vue';

export default {
  name: 'PaymentDetails',

  components: {
    ExchangeRateForm
  },

  mixins: [estimateTableHeight],

  data() {
    return {
      dateTime,
      STATUS,
      Table_Column,
      data: [],
      queryForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          timeField: 'completed_time',
          status: '', // 状态
          expenseType: '', // 费用类型
          costCenter: '', // 成本中心
          area: '', // 大区
          state: '', // 州
          station: '', // 网点
          serialNumber: '' // 单据编号
        }
      },
      total: 0,
      tableData: [],
      pickerOptions: {
        // 不能选择今天以后的时间（当天可以选择）
        disabledDate: (time) => {
          const now = new Date();
          const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
          return time.getTime() > today.getTime() + 24 * 60 * 60 * 1000 - 1;
        }
      },
      exchangeRateDialogVisible: false
    };
  },

  created() {
    this.handleQuery();
  },

  methods: {
    // 查询
    handleQuery() {
      this.queryForm.pageNumber = 1;
      this.getTableData();
    },

    // 重置
    onReset() {
      this.queryForm = {
        pageNumber: 1,
        pageSize: 10,
        params: {
          timeField: 'apply_time',
          status: '', // 状态
          expenseType: '', // 费用类型
          costCenter: '', // 成本中心
          area: '', // 大区
          state: '', // 州
          station: '', // 网点
          serialNumber: '' // 单据编号
        }
      };
      this.data = [];
      this.getTableData();
    },

    // 翻页
    getPageNumber(val) {
      this.queryForm.pageNumber = val;
      this.getTableData();
    },

    // 条数
    getPageSize(val) {
      this.queryForm.pageSize = val;
      this.getTableData();
    },

    // 参数转换
    getQueryParams() {
      const { params } = this.queryForm;
      if (this.data && this.data.length) {
        params.startTime = this.data[0];
        params.endTime = this.data[1];
      } else {
        params.startTime = '';
        params.endTime = '';
      }
      return params;
    },

    // 列表
    getTableData() {
      const params = this.getQueryParams();
      console.log(params);
      this.queryForm.params = params;
      apiFeishuExpensePage(this.queryForm).then(res => {
        console.log(res);
        const { records, total } = res.data;

        this.total = total;
        this.tableData = records;
      }).catch(err => {
        console.error(err);
      });
    },

    /**
     * 导出
     * @param type 1 导出列表 2 列表+附件
     */
    asyncApiStatisticsExport(type) {
      const API = type === 1 ? apiFeishuExpenseExport : apiFeishuExpenseExportAll;
      const obj = {
        ...this.queryForm.params
      };
      API(obj).then(() => {
        goFinanceExportPage();
      }).catch(err => {
        console.error(err);
      });
    },

    /**
     * 导出附件
     * @param row
     */
    exportFile(row) {
      apiLarkExpenseExportAttachment(row.id).then(res => {
        if (res.code === 200) {
          goFinanceExportPage();
        }
      });
    },

    // 打开弹窗
    asyncExchangeRate() {
      this.exchangeRateDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.exchangeRateFormRef.open();
      });
    },
    // 关闭
    close() {
      this.exchangeRateDialogVisible = false;
    },

    /**
     * 获取显示的文件列表（前3个，按上传时间倒序）
     */
    getDisplayFiles(fileList) {
      if (!fileList || fileList.length === 0) return [];
      // 前三条
      return fileList.slice(0, 3);
    },

    /**
     * 获取文件在原始列表中的索引
     */
    getOriginalIndex(fileList, file) {
      return fileList.findIndex(item => item.fileName === file.fileName);
    },

    /**
     * 文件预览
     * @param file 预览的文件集合
     * @param index 当前索引
     */
    previewFile(file, index) {
      console.log(file, index);
      // try {
      //   if (!file.attachmentList || !file.attachmentList[index]) {
      //     this.$message.warning(this.$t('basicData.FileNotFound') || '文件不存在');
      //     return;
      //   }
      //
      //   const targetFile = file.attachmentList[index];
      //   const fileUrl = targetFile.fileUrl || targetFile.url;
      //
      //   if (!fileUrl) {
      //     this.$message.warning(this.$t('basicData.FileLinkInvalid') || '文件链接无效');
      //     return;
      //   }
      //
      //   // 创建a标签下载
      //   const link = document.createElement('a');
      //   link.href = fileUrl;
      //   link.download = targetFile.fileName || 'download';
      //   link.target = '_blank';
      //   document.body.appendChild(link);
      //   link.click();
      //   document.body.removeChild(link);
      // } catch (error) {
      //   console.error(error);
      //   this.$message.error(this.$t('basicData.DownloadFailed') || '下载失败');
      // }
    },

    /**
     * 处理popover中文件点击
     */
    handleFileClick(row, index) {
      this.previewFile(row, index);
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep td.batchNumber .cell {
  color: #007efd !important;
  cursor: pointer;
}

.drawer_title {
  display: flex;
  align-items: center;

  .tips {
    margin-left: 10px;
    color: #909399;
    font-size: 14px;
    font-weight: 100;
  }
}

.table-but {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  gap: 10px;
}

.flex {
  display: flex;
}

.fileView {
  flex-direction: column;
  align-items: flex-start;
}
</style>
